if (!customElements.get('isu-sticky-checkout')) {
  customElements.define(
    'isu-sticky-checkout',
    class IsuStickyCheckout extends HTMLElement {
      constructor() {
        super();

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.mainCheckoutVisible = false;
        this.keyboardOpen = false;
        this.updateVisibility = this.updateVisibility.bind(this);
        this.onViewportResize = this.onViewportResize.bind(this);
      }

      connectedCallback() {
        this.mainCheckout = document.getElementById(this.dataset.mainCheckoutId);
        if (!this.mainCheckout) return;

        this.intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            this.mainCheckoutVisible = entry.isIntersecting;
            this.updateVisibility();
          },
          { threshold: [0, 0.15] }
        );
        this.intersectionObserver.observe(this.mainCheckout);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.updateVisibility);
        } else {
          this.mobileQuery.addListener(this.updateVisibility);
        }

        window.visualViewport?.addEventListener('resize', this.onViewportResize);
        this.onViewportResize();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.updateVisibility);
        } else {
          this.mobileQuery.removeListener(this.updateVisibility);
        }
        window.visualViewport?.removeEventListener('resize', this.onViewportResize);
      }

      onViewportResize() {
        const viewportHeight = window.visualViewport?.height;
        this.keyboardOpen = Boolean(viewportHeight && viewportHeight < window.innerHeight * 0.72);
        this.updateVisibility();
      }

      updateVisibility() {
        const shouldShow = this.mobileQuery.matches && !this.mainCheckoutVisible && !this.keyboardOpen;
        this.hidden = !shouldShow;
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }
    }
  );
}
